import Vue from 'vue'
import Tabs from './components/Tabs.vue'


Vue.config.productionTip = false
Vue.use(Tabs)
Vue.component("tabs",Tabs)
window.Vue=Vue;
new Vue().$mount('#hometabs')
